import { useState } from 'react';

export default function OperationsChart() {
  const [period, setPeriod] = useState('month');

  const data = [
    { label: 'Ene', value: 45, max: 80 },
    { label: 'Feb', value: 52, max: 80 },
    { label: 'Mar', value: 61, max: 80 },
    { label: 'Abr', value: 58, max: 80 },
    { label: 'May', value: 67, max: 80 },
    { label: 'Jun', value: 73, max: 80 },
  ];

  return (
    <div className="bg-white rounded-lg p-6 border border-gray-200">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-bold text-[#0A2A43]">Operaciones por Mes</h3>
          <p className="text-sm text-[#6B7280] mt-1">Evolución de gestiones aduaneras</p>
        </div>
        <div className="flex gap-2">
          {['week', 'month', 'year'].map((p) => (
            <button
              key={p}
              onClick={() => setPeriod(p)}
              className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors cursor-pointer whitespace-nowrap ${
                period === p
                  ? 'bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white'
                  : 'bg-gray-100 text-[#6B7280] hover:bg-gray-200'
              }`}
            >
              {p === 'week' ? 'Semana' : p === 'month' ? 'Mes' : 'Año'}
            </button>
          ))}
        </div>
      </div>

      <div className="flex items-end justify-between gap-4 h-64">
        {data.map((item, index) => (
          <div key={index} className="flex-1 flex flex-col items-center gap-2">
            <div className="w-full flex flex-col justify-end h-full">
              <div
                className="w-full bg-gradient-to-t from-[#114B7A] to-[#2F80ED] rounded-t-md transition-all hover:opacity-80 cursor-pointer"
                style={{ height: `${(item.value / item.max) * 100}%` }}
              ></div>
            </div>
            <div className="text-center">
              <p className="text-xs font-semibold text-[#0A2A43]">{item.value}</p>
              <p className="text-xs text-[#6B7280] mt-1">{item.label}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}